// src/pages/Activities.js
import React, { useState, useEffect, Link } from 'react';
import { useAuth } from '../hooks/useAuth';
import { getActivities, completeActivity , assignToAll  } from '../services/activityService';
import { useNavigate } from 'react-router-dom';

const Activities = () => {
  const { user } = useAuth();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      const data = await getActivities(user.id);
      setActivities(data);
      setLoading(false);
    } catch (error) {
      setError('Failed to load activities');
      setLoading(false);
    }
  };
  
  const handleAssignToAll = async (activityId) => {
    try {
      await assignToAll(activityId);
      console.log("assignToAll");
      // Refresh the list
      fetchActivities();
    } catch (error) {
      setError('Failed to complete activity');
    }
  };
  const handleCompleteActivity = async (activityId) => {
    try {
      await completeActivity(user.id, activityId);
      // Refresh the list
      fetchActivities();
    } catch (error) {
      setError('Failed to complete activity');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
<div className="dashboard-container">
  <h1>Welcome, {user.name}!</h1>
  <h2>Activities</h2>
  
  {activities.length === 0 ? (
    <p className="no-activities">No activities</p>
  ) : (
    
    <div className="table-responsive">
      <button 
          onClick={() => navigate(`/create-activity`)}>
            New activity
      </button>
      <table className="activities-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Content</th>
            <th>Sort</th>
            <th>Number of users</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((activity) => (
            <tr key={activity.id} className="activity-row">
              <td className="activity-name">{activity.name}</td>
              <td className="activity-type">{activity.type}</td>
              <td className="activity-content">
                {activity.content ? activity.content : "-"}
              </td>
              <td className="activity-sort">{activity.sort}</td>
              <td className="activity-type">{activity.completedUserActivities} / {activity.totalUserActivities}</td>

              <td className="activity-actions">

                <button 
                      onClick={() => navigate(`/activities/edit/${activity.id}`)}
                    >
                      edit
                </button>
                <button
                  onClick={() => handleAssignToAll(activity.id)}
                  className="complete-button">assignToAll</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>
  );
};

export default Activities;